import Panel from './Panel';

export default Panel;



// WEBPACK FOOTER //
// ./src/components/atoms/Panel/index.js